<template>
  <v-layout
    v-if="bots != undefined"
    wrap
    mt-1
  >
    <helper-buy-pack ref="buyPack" />
    <v-flex
      v-for="(bot,i) in bots"
      :key="i"
      md4
      xs12
    >
      <v-card class="bot-card">
        <v-flex
          class="cover"
          :style="{ backgroundColor: bot.bgcolor}"
          xs12
          md12
        >
          <v-avatar
            v-if="bot.logo !== null"
            :tile="false"
            class="avatar"
            :size="110"
          >
            <v-img
              :src="bot.logo"
              :lazy-src="bot.logo"
              max-height="110"
              contain
            />
          </v-avatar>
          <v-avatar
            v-else
            class="avatar"
            style="pointer: cursor;"
            :tile="false"
            :size="110"
            color="#fff"
          >
            <component :is="newIcon" />
          </v-avatar>
        </v-flex>

        <v-flex
          justify-self-center
          text-center
          class="name"
        >
          <h4>{{ bot.name }}</h4>
          <p style="margin-bottom:0;">
            {{ bot.exchange }}
          </p>
        </v-flex>

        <div class="description">
          <template>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ bot.description }}
            </v-tooltip>
          </template>
        </div>
        <v-divider />
        <v-card-text>
          <v-layout
            wrap
            class="data"
          >
            <v-flex
              xs6
              pl-10
            >
              <span>{{ $t('globals.minDeposit') }}</span>
              <p>{{ bot.mindeposit }} USDT</p>
              <span>{{ $t('bots.botType') }}</span>
              <p>{{ bot.type }}</p>
            </v-flex>
            <v-flex
              xs6
              pl-10
            >
              <span>{{ $t('bots.managementFee') }}</span>
              <p>{{ bot.management_fee }}%</p>
              <span>{{ $t('bots.activeUsers') }}</span>
              <p class="text-primary">
                {{ bot.active_bots }}
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <small style="margin-left:5px;">
            {{ $t('bots.risk') }}:
            <b :class="colorStatus(bot.risk)">{{ $t('bots.' + bot.risk) }}</b>
          </small>

          <!-- <small v-if="bot.activations_for_user == 0">{{$t('bots.notInstalled')}}</small>
          <small v-else>{{$t('bots.botActivated')}}: <b>{{bot.activations_for_user}}</b></small>-->
          <v-spacer />
          <v-btn
            class="primary"
            small
            @click="installBot(bot.id)"
          >
            {{ $t('bots.installButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout
    v-else
    v-show="!$apollo.loading"
    wrap
    justify-center
  >
    <v-flex
      md5
      xs12
      new-record
      mt-5
    >
      <v-card style="padding:50px">
        <component :is="newIcon" />
        <h3>{{ $t('bots.myTradingBots') }}</h3>
        <p>{{ $t('bots.botsNotFound') }}</p>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
const BOTS_QUERY = require("@/graphql/queries/Bots.gql");
import IconBots from "@/components/icons/IconBots.vue";
import { mapGetters } from "vuex";

export default {
  name: "Bots",
  data() {
    return {
      newIcon: IconBots,
      loading: false
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    installBot(id) {
      if (this.getUser.pack !== null || this.getUser.vip_client)
        this.$router.push("/traderbots/install/" + id);
      else this.$refs.buyPack.open();
    }
  },
  apollo: {
    bots: {
      query: BOTS_QUERY
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
